import { FormActivityLogApiResponse } from '@features/forms/types/formActivityLogApi';

export const MOCK_FORM_ACTIVITY_LOG_API: FormActivityLogApiResponse = {
  data: [
    {
      action_id: 'action_v2_status',
      version: 2,
      action_type: 'STATUS_UPDATE',
      timestamp: '2026-05-15T16:00:00.000Z',
      updated_by: 'Neha',
      modified_data: [
        {
          field: 'status',
          previous_value: 'published',
          current_value: 'paused'
        }
      ]
    },
    {
      action_id: 'action_v2_update',
      version: 2,
      action_type: 'UPDATE',
      timestamp: '2026-05-15T15:10:00.000Z',
      updated_by: 'Neha',
      modified_data: [
        {
          field: 'name',
          previous_value: 'Admission 2k26',
          current_value: 'Admissions: 2026'
        },
        {
          field: 'add_to',
          previous_value: 'Member List',
          current_value: 'LKG A'
        },
        {
          field: 'registration_end_time',
          previous_value: '2026-06-15T15:10:00.000Z',
          current_value: null
        },
        {
          field: 'source',
          previous_value: null,
          current_value: 'twitter'
        },
        {
          field: 'form_field',
          previous_value: null,
          current_value: null,
          metadata: [
            {
              change: 'FIELD_ADDED',
              field_name: 'Date of Birth',
              field_type: 'date',
              is_required: true,
              field_options: [],
              display_order: 3
            },
            {
              change: 'FIELD_REMOVED',
              field_name: 'DOB',
              field_type: 'date',
              is_required: true,
              field_options: [],
              display_order: 3
            },
            {
              change: 'ORDER_CHANGED',
              field_name: 'Class',
              field_type: 'single_choice',
              is_required: true,
              field_options: ['10th', '11th', '12th'],
              display_order: 4
            },
            {
              change: 'MARKED_REQUIRED',
              field_name: 'Section',
              field_type: 'single_choice',
              is_required: true,
              field_options: ['A', 'B', 'C'],
              display_order: 5
            },
            {
              change: 'MARKED_OPTIONAL',
              field_name: 'Student Photo',
              field_type: 'file',
              is_required: false,
              field_options: [],
              display_order: 6
            }
          ]
        }
      ]
    },
    {
      action_id: 'action_v1_create',
      version: 1,
      action_type: 'CREATE',
      timestamp: '2026-05-15T14:37:21.123Z',
      updated_by: 'Neha',
      modified_data: []
    }
  ],
  pagination: {
    page: 0,
    limit: 10,
    total_rows: 3,
    last_page: true
  }
};

export default MOCK_FORM_ACTIVITY_LOG_API;
